export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

export default {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
};
